import { atom } from "@reatom/framework";
import {
  getOrdersByDatesWithDebouncing,
  getOrdersByStatusesWithDebouncing,
} from "src/pages/AdminDashboardPage/store/action";

const now = new Date();

export const dashboardDateRangeAtom = atom(
  {
    startDate: new Date(now.getFullYear(), now.getMonth(), 1).toISOString(),
    endDate: now.toISOString(),
  },
  "dashboardDateRangeAtom",
);

dashboardDateRangeAtom.onChange((ctx) => {
  getOrdersByDatesWithDebouncing(ctx);
  getOrdersByStatusesWithDebouncing(ctx);
});
